import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Axios from 'axios';
import Notifications from '@kyvg/vue3-notification';
import { plugin as VueTippy } from 'vue-tippy';
import mitt from 'mitt';
import moment from 'moment';
import SlideUpDown from 'vue3-slide-up-down';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import Loading from '@/components/ui/Loading.vue';
import Button from '@/components/ui/Button.vue';
import JsDownload from 'js-file-download';
import GetValidImageUrl from './utils/GetValidImageUrl';
import QueueProgress from './components/ui/QueueProgress.vue';
import { ElLoading } from 'element-plus';
import 'tippy.js/dist/tippy.css'; // optional for styling
import '@/assets/sass/_element.scss';

const emitter = mitt();
const projectName = process.env.VUE_APP_PROJECT || 'motom';
console.log('current project is => ', projectName);

const VueUploadComponent = require('vue-upload-component');

let ajax_url = '';
let download_url = 'https://www.portal-demo.motom.me';

if (process.env.VUE_APP_API && process.env.VUE_APP_API === 'local') {
  ajax_url = 'https://dev.brand-portal.motom.com:8443/api/v1';
  download_url = 'https://dev.brand-portal.motom.com:8443';
} else if (process.env.NODE_ENV === 'development') {
  // ajax_url = 'https://www.anchor.dev.motom.me/api/v1';
  ajax_url =
    projectName === 'sephora' ? 'https://sephora-qa.app.anchor.store/api/v1' : projectName === 'cj' ? 'https://cj-qa.app.anchor.store/api/v1': `https://www.anchor.qa.motom.me/api/v1`;
  download_url = 'https://www.portal-demo.motom.me';
} else {
  ajax_url = '/api/v1';
  download_url = `https://${location.host}`;
}

const headers = {};
const access_token = window.localStorage.getItem('access_token');
if (access_token !== null) {
  headers.Authorization = 'Bearer ' + access_token;
  headers.Accept = 'application/json';
  headers['Content-Type'] = 'application/json';
}

const ajax = Axios.create({
  baseURL: ajax_url,
  headers: headers,
  withCredentials: true,
});

ajax.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response && error.response.data) {
      let msg = '';
      if (typeof error.response.data.message === 'string') {
        msg = error.response.data.message;
      } else if (typeof error.response.data.data === 'string') {
        msg = error.response.data.data;
      } else if (typeof error.response.data.data.message === 'string') {
        msg = error.response.data.data.message;
      } else if (typeof error.response.data.data.data === 'string') {
        msg = error.response.data.data.data;
      } else if (typeof error.response.data.data.data.message === 'string') {
        msg = error.response.data.data.data.message;
      }

      if (
        msg === 'System Error User is not logged in.' ||
        msg === 'AuthenticationException with message Unauthenticated.'
      ) {
        window.localStorage.removeItem('access_token');
        window.location.replace('/login');
      }
    }

    throw error;
  }
);

const app = createApp(App);
app.use(store);
app.use(router);
app.use(Notifications);
app.use(ElLoading);
app.use(VueTippy);

app.component('file-upload', VueUploadComponent);
app.component('slide-up-down', SlideUpDown);
app.component('svg-icon', SvgIcon);
app.component('ui-button', Button);
app.component('ui-loading', Loading);
app.component('queue-progress', QueueProgress);

// app.provide('$ajax', ajax);
app.config.globalProperties.$ajax = ajax;
app.config.globalProperties.EventBus = emitter;
app.config.globalProperties.$filters = {
  momentFormat(date, format) {
    if (date) return moment(date).format(format);
    else return '---';
  },
};

app.config.globalProperties.$ProjectName = projectName;
app.config.globalProperties.$DownloasUrl = download_url;
app.config.globalProperties.$JsDownload = JsDownload;
app.config.globalProperties.$Get_Image = GetValidImageUrl;

app.mount('#app');
